import axios from 'axios';

// API Gateway URL
const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://4qhnaidrdj.execute-api.us-east-1.amazonaws.com/dev';

// S3 Configuration
const BUCKET_NAME = 'dozer-web-250503';
const S3_URL_PREFIX = `https://${BUCKET_NAME}.s3.amazonaws.com/`;

// Convert S3 URL to public URL
export const getPublicUrl = (key) => {
  if (!key) return null;
  
  // If already a full URL, return as is
  if (key.startsWith('http')) {
    return key;
  }
  
  // Remove leading slash if present
  const cleanKey = key.startsWith('/') ? key.substring(1) : key;
  return `${S3_URL_PREFIX}${cleanKey}`;
};

// Helper function to convert file to base64
const fileToBase64 = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });
};

// Upload a file to S3 through our API
export const uploadToS3 = async (file, customKey = null) => {
  try {
    if (!file) {
      throw new Error('No file provided for upload');
    }
    
    console.log('准备上传文件:', file.name, file.type, file.size);
    
    // 将文件转换为base64
    const base64Data = await fileToBase64(file);
    console.log('文件已转换为base64');
    
    // 创建JSON payload，而不是FormData
    // base64Data格式为: "data:image/jpeg;base64,/9j/4AAQSkZJRg..."
    // 需要移除前缀部分
    const base64Content = base64Data.split(',')[1];
    
    const payload = {
      file: base64Content,
      filename: file.name,
      contentType: file.type,
      key: customKey || undefined
    };
    
    console.log('发送JSON格式的文件数据');
    
    // Upload through our API
    const response = await axios.post(`${API_BASE_URL}/api/media/upload`, payload, {
      headers: {
        'Content-Type': 'application/json',
      }
    });
    
    console.log('上传成功:', response.data);
    return response.data;
  } catch (error) {
    console.error('Error uploading to S3:', error);
    if (error.response) {
      console.error('Response data:', error.response.data);
      console.error('Response status:', error.response.status);
    }
    throw error;
  }
};

// Delete a file from S3 through our API
export const deleteFromS3 = async (key) => {
  try {
    if (!key) {
      throw new Error('No key provided for deletion');
    }
    
    // If the key is a full URL, extract just the key part
    if (key.startsWith(S3_URL_PREFIX)) {
      key = key.substring(S3_URL_PREFIX.length);
    }
    
    // Delete through our API
    await axios.delete(`${API_BASE_URL}/api/media/${encodeURIComponent(key)}`);
    
    return true;
  } catch (error) {
    console.error('Error deleting from S3:', error);
    throw error;
  }
};

// List files from S3 through our API
export const listFilesFromS3 = async (prefix = '') => {
  try {
    // Get the list through our API
    const response = await axios.get(`${API_BASE_URL}/api/media`, {
      params: { prefix }
    });
    
    return response.data;
  } catch (error) {
    console.error('Error listing files from S3:', error);
    throw error;
  }
};

// Convert S3 media item to format needed by application
export const formatS3MediaItem = (s3Item, title = null) => {
  return {
    id: Date.now(), // Generate a unique ID
    title: title || s3Item.key.split('/').pop(), // Use filename if no title provided
    url: s3Item.url,
    type: 'image', // Assuming all uploads are images
    uploadDate: new Date(s3Item.lastModified || Date.now()).toISOString().split('T')[0],
    size: `${Math.round((s3Item.size || 0) / 1024)} KB`,
    s3Key: s3Item.key // Store the S3 key for later reference
  };
};

export default {
  uploadToS3,
  deleteFromS3,
  listFilesFromS3,
  getPublicUrl,
  formatS3MediaItem
};